<div class="app-container">
  <page-header [icon]="'far-shopping-cart'" [title]="'orders'">
    <ng-container class="header-button">
      @if (canCreate()) {
        <btn
          [routerLink]="['/order/customer']"
          [label]="'order.create'"
          [title]="'order.create' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [dataCyAttribute]="'create-order'"
        ></btn>
      }
      @if (canCreate()) {
        <app-exports #exportsModal [entity]="'orders'"></app-exports>
      }
      <modal-orders-import
        [carriers]="queryCompanyCarriers.data()"
        [checkouts]="queryCheckouts.data()"
        [payments]="queryPayments.data()"
        (onOrdersImported)="queryOrders.refetch()"
        [dataCyAttribute]="'imports'"
      ></modal-orders-import>
    </ng-container>
  </page-header>

  <section class="content">
    <!--    todo tags mb nemusim pasovat, ale udelat si taky quuery v base listingu?-->
    <app-filter-form
      [filters]="submittedQueryFilters()"
      [filtersForExport]="submittedQueryFilters()"
      [loading]="areCoreDataLoading()"
      [entity]="'orders'"
      [isInOrders]="true"
      [areAllOrdersChecked]="areAllOrdersChecked()"
      [tags]="queryTags.data()"
      [isExportButtonShown]="true"
      [totalItems]="totalItems()"
      [isShowingTags]="isShowingTags()"
      [filterVisible]="filtersExpanded"
      [allFilters]="filters()"
      [defaultFilters]="defaultFilters"
      [advancedFilterKeys]="advancedFilterKeys"
      (onSubmit)="onFilterSubmit()"
      (onClearClick)="clearFilters()"
      (onExportResult)="queryOrders.refetch()"
      (onCreateModalHidden)="exportsModal.showChildModal()"
      (onDownloadInvoices)="onDownloadInvoices($event)"
      (setCheckedOrdersToFalse)="setCheckedOrdersToFalse()"
      [checkedOrders]="checkedOrders()"
      [payments]="queryPayments.data()"
      [carriers]="queryCompanyCarriers.data()"
      [checkedMap]="checkedMap"
    >
      <div class="container-fluid ps-0 pe-0">
        <!--      FIRST ROW OF INPUTS-->
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <form-row-input
              [label]="'fulltext'"
              [icon]="null"
              [model]="filters().fulltext"
              (modelChange)="setFilters('fulltext', $event)"
              (keyup.enter)="onFilterSubmit()"
              [dataCyAttribute]="'order-name-filter'"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
            <form-row-input
              [label]="'orders.dateCreated.from'"
              [icon]="null"
              [inputType]="'date'"
              [model]="filters().dateCreated?.left_date"
              (modelChange)="setFilters('dateCreated', $event, 'left_date')"
              [dataCyAttribute]="'orders-date-created-from-filter'"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
            <form-row-input
              [label]="'orders.dateCreated.to'"
              [icon]="null"
              [inputType]="'date'"
              [model]="filters().dateCreated?.right_date"
              (modelChange)="setFilters('dateCreated', $event, 'right_date')"
              [dataCyAttribute]="'orders-date-created-to-filter'"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
            <form-row-select
              [label]="'processStatus'"
              [icon]="null"
              [model]="filters().processStatus"
              (modelChange)="setFilters('processStatus', $event)"
              [options]="processStatesOptions"
              [dataCyAttribute]="'orders-process-status-filter'"
            ></form-row-select>
          </div>
          <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
            <modal-customer-search
              [customer]="filters().customer"
              (customerChange)="setFilters('customer', $event)"
              [isOnOrdersPage]="true"
            ></modal-customer-search>
          </div>
        </div>
        <!--      SECOND ROW OF INPUTS-->
        <!--        todo prevent breaking default opening filters if filters filled by changing class custom-dropdown-->
        <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
          <div class="row">
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.orderNumber'"
                [icon]="null"
                [pattern]="'^[0-9]+$'"
                [model]="filters().reservationNumber"
                (modelChange)="setFilters('reservationNumber', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'orders-reservation-number-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.billNumber'"
                [icon]="null"
                [pattern]="'^[0-9]+$'"
                [model]="filters().billNumber"
                (modelChange)="setFilters('billNumber', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'orders-bill-number-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.externalId'"
                [icon]="null"
                [pattern]="'^[0-9]+$'"
                [model]="filters().externalId"
                (modelChange)="setFilters('externalId', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'orders-external-id-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'package'"
                [icon]="null"
                [model]="filters().package"
                (modelChange)="setFilters('package', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'orders-package-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'item'"
                [icon]="null"
                [model]="filters().item"
                (modelChange)="setFilters('item', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'orders-item-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select-multiple
                [label]="'tags'"
                [options]="queryTags.data()"
                [selectedValues]="filters().tags"
                (selectedValuesChange)="setFilters('tags', $event)"
                [isTags]="true"
                [dataCyAttribute]="'orders-tags-filter'"
              ></form-row-select-multiple>
            </div>
          </div>
          <!--      THIRD ROW OF INPUTS-->
          <div class="row">
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select-multiple
                [label]="'tagsNegate'"
                [options]="queryTags.data()"
                [selectedValues]="filters().tagsNegate"
                (selectedValuesChange)="setFilters('tagsNegate', $event)"
                [isTags]="true"
                [dataCyAttribute]="'orders-tagsNegate-filter'"
              ></form-row-select-multiple>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select
                [label]="'order.status'"
                [icon]="null"
                [model]="filters().status"
                (modelChange)="setFilters('status', $event)"
                [options]="statusTypesOptions"
                [dataCyAttribute]="'orders-status-filter'"
              ></form-row-select>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select
                [label]="'hasAvailableProducts'"
                [icon]="null"
                [model]="filters().hasAvailableProducts"
                (modelChange)="setFilters('hasAvailableProducts', $event)"
                [options]="hasAvailableProductsOptions"
                [dataCyAttribute]="'orders-hasAvailableProducts-filter'"
              ></form-row-select>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select-multiple
                [label]="'carriers'"
                [selectedValues]="filters().carriers"
                (selectedValuesChange)="setFilters('carriers', $event)"
                [options]="carrierFilterOptions()"
                [dataCyAttribute]="'orders-carrier-filter'"
              ></form-row-select-multiple>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select-multiple
                [label]="'payments'"
                [options]="queryPayments.data()"
                [selectedValues]="filters().payments"
                (selectedValuesChange)="setFilters('payments', $event)"
                [dataCyAttribute]="'orders-payments-filter'"
              ></form-row-select-multiple>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select-multiple
                [label]="'products.checkouts'"
                [options]="queryCheckouts.data()"
                [selectedValues]="filters().checkouts"
                (selectedValuesChange)="setFilters('checkouts', $event)"
                [dataCyAttribute]="'orders-checkout-filter'"
              ></form-row-select-multiple>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
              <form-row-select-multiple
                [label]="'products.depots'"
                [options]="queryDepotsOptions.data()"
                [selectedValues]="filters().depots"
                (selectedValuesChange)="setFilters('depots', $event)"
                [dataCyAttribute]="'orders-depots-filter'"
              ></form-row-select-multiple>
            </div>
            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
              <form-row-select
                [label]="'isPaid'"
                [options]="isPaidOptions"
                [model]="filters().isPaid"
                (modelChange)="setFilters('isPaid', $event)"
                [dataCyAttribute]="'orders-isPaid-filter'"
              ></form-row-select>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'dateExpedition.from'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateExpedition?.left_date"
                (modelChange)="setFilters('dateExpedition', $event, 'left_date')"
                [dataCyAttribute]="'orders-date-expedition-from-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'dateExpedition.to'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateExpedition?.right_date"
                (modelChange)="setFilters('dateExpedition', $event, 'right_date')"
                [dataCyAttribute]="'orders-date-expedition-to-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
              <form-row-select
                [label]="'priority'"
                [options]="priorityOptions"
                [model]="filters().priority"
                (modelChange)="setFilters('priority', $event)"
                [dataCyAttribute]="'orders-priority-filter'"
              ></form-row-select>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select-multiple
                [label]="'createdBy'"
                [selectedValues]="filters().createdBy"
                (selectedValuesChange)="setFilters('createdBy', $event)"
                [options]="queryUsers.data()"
                [dataCyAttribute]="'order-createdBy-filter'"
              ></form-row-select-multiple>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.dateBill.from'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateBill?.left_date"
                (modelChange)="setFilters('dateBill', $event, 'left_date')"
                [dataCyAttribute]="'orders-date-bill-from-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.dateBill.to'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateBill?.right_date"
                (modelChange)="setFilters('dateBill', $event, 'right_date')"
                [dataCyAttribute]="'orders-date-bill-to-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.dateTax.from'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateTax?.left_date"
                (modelChange)="setFilters('dateTax', $event, 'left_date')"
                [dataCyAttribute]="'orders-date-tax-from-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.dateTax.to'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateTax?.right_date"
                (modelChange)="setFilters('dateTax', $event, 'right_date')"
                [dataCyAttribute]="'orders-date-tax-to-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.dateDue.from'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateDue?.left_date"
                (modelChange)="setFilters('dateDue', $event, 'left_date')"
                [dataCyAttribute]="'orders-date-due-from-filter'"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-input
                [label]="'orders.dateDue.to'"
                [icon]="null"
                [inputType]="'date'"
                [model]="filters().dateDue?.right_date"
                (modelChange)="setFilters('dateDue', $event, 'right_date')"
                [dataCyAttribute]="'orders-date-due-to-filter'"
              ></form-row-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
              <form-row-select
                [label]="'orders.shippingCountry'"
                [options]="shippingCountriesOptions"
                [optionKey]="'code'"
                [model]="filters().shippingCountry"
                (modelChange)="setFilters('shippingCountry', $event)"
                [dataCyAttribute]="'orders-shippingCountry-filter'"
              ></form-row-select>
            </div>
          </div>
        </div>
      </div>
    </app-filter-form>
    <!--    *ngIf="!areCoreDataLoading()"-->
    <app-base-listing
      [query]="queryOrders"
      [filters]="submittedViewFilters()"
      [isColumnSettingVisible]="true"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
      [listName]="'orders'"
      [areAllOrdersCheckboxChecked]="areAllOrdersChecked()"
      (areAllOrdersCheckboxCheckedChange)="areAllOrdersCheckboxCheckedChanged($event)"
      [columns]="listingColumns"
      [selectedColumns]="selectedColumns"
      (areAllOrdersCheckedChange)="allOrdersChecked($event)"
      [checkedMap]="checkedMap"
      (callAction)="callAction($event)"
      [storageKey]="storageKey()"
    >
      <!--      (saveSettings)="saveSettings()"-->
      <!--      -->
      <!--      [items]="orders()"-->
      <!--      [checkedOrders]="checkedOrders()"-->
      <!--      [columns]="listingColumns"-->
      <!--      (setCheckedOrdersToFalse)="setCheckedOrdersToFalse()"-->
      <!--      (orderChecked)="toggleChecked($event.id, $event.checked)"-->
      <!--      (allOrdersWasChecked)="allOrdersChecked($event)"-->
      <!--      [areAllListedOrdersChecked]="areAllListedOrdersChecked"-->
    </app-base-listing>
  </section>
  <modal-loading #loadingModal></modal-loading>
</div>
